// extracted by mini-css-extract-plugin
module.exports = {"link":"link-module--link--1g7Ui","icon":"link-module--icon--3cX5J"};